'use client';

import React from 'react';

import Skeleton from 'react-loading-skeleton';

import styles from './loading-product-configuration.module.scss';

const ProductSelectionSkeleton = () => (
  <div className={styles['config-skeleton']}>
    <Skeleton width={35} height={20} />
    <Skeleton width={270} height={50} />
    <Skeleton width={400} height={100} count={3} />
  </div>
);

const OrderDetailsSkeleton = () => (
  <div className={styles['order-details-skeleton']}>
    <Skeleton width={100} height={20} />
    <Skeleton width={400} height={50} />
    <Skeleton width={400} height={25} />
  </div>
);

export const LoadingProductConfiguration = () => (
  <div className={styles['skeleton-container']}>
    <div className={styles['section']}>
      <div className={styles['image-container']}>
        <Skeleton width={350} height={300} />
      </div>
      <ProductSelectionSkeleton />
    </div>
    <div className={styles['section']}>
      <div className={styles['image-container']}>
        <Skeleton width={350} height={300} />
      </div>
      <ProductSelectionSkeleton />
    </div>
    <div className={styles['section']}>
      <div className={styles['image-container']}>
        <Skeleton width={350} height={300} />
      </div>
      <OrderDetailsSkeleton />
    </div>
  </div>
);
